export default __webpack_public_path__ + "static/media/tracking-finished.15bc859d.png";